<div class="row">
  <div class="small-12 columns">
    <div class="input-group margin-reset">
      <span class="input-group-label bg-secondary cursor-hover" style="border: 1px solid #E6E6E6;background: #ffffff;">
        <em class="fa fa-search dark-grey"></em>
      </span>
      <input class="default input-group-field account-search-input" placeholder="Rechercher un client" required="" type="text" value=""
             (keyup)="keyUp.next($event)">
    </div>
    <div *ngIf="showSpinnerResearch || filteredAccounts?.length" data-dropdown data-auto-focus="true" class="account-search-results">
      <div *ngIf="showSpinnerResearch" class="widget-spinner padding-v-l">
        <div></div>
      </div>
      <div *ngIf="filteredAccounts?.length && !showSpinnerResearch" class="list condensed"
           style="max-height:160px; overflow-y:scroll;">
        <a *ngFor="let account of filteredAccounts" class="item" (click)="onAccountSelected(account)">{{account.name}}</a>
      </div>
    </div>
  </div>
</div>
